import React from "react";
import Sortable from "react-sortablejs";
import "./index.less";
import middleware from "../../middleware";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.sortable = null; // sortable instance
  }

  componentDidMount() {}

  getPropsOptions = () => {
    const {
      draggableType = "row",
      ghostClass = "",
      chosenClass = "",
      dragClass = "",
      ignoreClass = "",
      isAnimation = true
    } = this.props;

    return {
      filter: ignoreClass ? `.${ignoreClass}` : ".wea-ignore-node",
      handle: draggableType === "icon" ? ".sortable-handle" : "",
      ghostClass: ghostClass ? ghostClass : "wea-sortable-ghost", // Class name for the drop placeholder
      chosenClass: chosenClass ? chosenClass : "wea-sortable-chosen", // Class name for the chosen item
      dragClass: dragClass ? dragClass : "wea-sortable-drag", // Class name for the dragging item
      animation: isAnimation ? 150 : 0 // ms, animation speed moving items when sorting, `0` — without animation
    };
  };

  renderItemlist = () => {
    const {
      datas,
      className = "",
      draggableType = "row",
      renderNodeItem,
      ignoreClass = ""
    } = this.props;

    const itemCls = `wea-sortable-list-item ${className} `;
    const ignoreCls = ignoreClass ? ignoreClass : "wea-ignore-node";

    return datas.map(val => (
      <li
        className={`${itemCls} ${val.filter ? ignoreCls : ""}`}
        key={val.id}
        data-id={val.id}
        style={val.filter ? { cursor: "not-allowed" } : null}
      >
        {draggableType === "icon" ? (
          <i className="icon-coms-move sortable-handle" />
        ) : null}
        {typeof renderNodeItem === "function" ? (
          renderNodeItem(val)
        ) : (
          <span
            className="wea-sortable-list-item-label"
            style={{ marginLeft: draggableType === "icon" ? "8px" : null }}
          >
            {val.name}
          </span>
        )}
      </li>
    ));
  };

  onChange = (order, sortable, evt) => {
    const { datas, onChange } = this.props;
    console.log(datas, order);
    datas.sort((a, b) => {
      return order.indexOf(String(a.id)) - order.indexOf(String(b.id));
    });

    typeof onChange === "function" && onChange(datas, sortable, evt);
  };

  render() {
    return (
      <Sortable
        // Sortable options (https://github.com/RubaXa/Sortable#options)
        options={{ ...this.getPropsOptions() }}
        // [Optional] Use ref to get the sortable instance
        // https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute
        ref={c => {
          if (c) {
            this.sortable = c.sortable;
          }
        }}
        // [Optional] A tag or react component to specify the wrapping element. Defaults to "div".
        // In a case of a react component it is required to has children in the component
        // and pass it down.
        tag="ul"
        // [Optional] The onChange method allows you to implement a controlled component and keep
        // DOM nodes untouched. You have to change state to re-render the component.
        // @param {Array} order An ordered array of items defined by the `data-id` attribute.
        // @param {Object} sortable The sortable instance.
        // @param {Event} evt The event object.
        onChange={(order, sortable, evt) => {
          this.onChange(order, sortable, evt);
        }}
      >
        {this.renderItemlist()}
      </Sortable>
    );
  }
}

const Com = middleware(Main, "WeaSortable");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-sortable/index.js